export default "__VITE_ASSET__Cx1ALKOx__"